module.exports = __webpack_public_path__ + "assets/img/FD.6e24fb6e.png";